import { render, staticRenderFns } from "./ToolTop.vue?vue&type=template&id=12f063d6&"
import script from "./ToolTop.vue?vue&type=script&lang=js&"
export * from "./ToolTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports